import { h } from 'preact';
import './close_control.scss';
import { IoIosClose } from 'react-icons/io';
import { accessible } from 'utilities/accessibility';

export const CloseControl = ({
    styles = {},
    onClick = () => {},
    children 
}) => {
    const attrs = {
        close: {
            onClick,
            ...accessible(onClick)
        }
    };

    return (
        <div className="close-control" style={ styles }>
            <IoIosClose { ...attrs.close }/>
            { children }
        </div>
    )
}